import { Grid } from '@material-ui/core';
import { EntityAboutCard, EntityLayout, EntitySwitch, isKind } from '@backstage/plugin-catalog';
import { EntityApiDefinitionCard, EntityProvidedApisCard, EntityProvidingComponentsCard } from '@backstage/plugin-api-docs';
import { EntityKubernetesContent, isKubernetesAvailable } from '@backstage/plugin-kubernetes';
import { EntityTechdocsContent } from '@backstage/plugin-techdocs';

export const entityPage = <EntitySwitch>
  <EntitySwitch.Case if={isKind('api')}>
    <EntityLayout>
      <EntityLayout.Route path="/" title="Definition"><EntityApiDefinitionCard /></EntityLayout.Route>
      <EntityLayout.Route path="/services" title="Services"><EntityProvidingComponentsCard /></EntityLayout.Route>
    </EntityLayout>
  </EntitySwitch.Case>
  <EntitySwitch.Case>
    <EntityLayout>
      <EntityLayout.Route path="/" title="Overview">
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}><EntityAboutCard /></Grid>
          <Grid item xs={12} md={6}><EntityProvidedApisCard /></Grid>
        </Grid>
      </EntityLayout.Route>
      <EntityLayout.Route path="/kubernetes" title="Kubernetes" if={isKubernetesAvailable}><EntityKubernetesContent /></EntityLayout.Route>
      <EntityLayout.Route path="/docs" title="Docs" if={entity => Boolean(entity.metadata.annotations?.['backstage.io/techdocs-ref'])}><EntityTechdocsContent /></EntityLayout.Route>
    </EntityLayout>
  </EntitySwitch.Case>
</EntitySwitch>;
